import * as THREE from 'three';
import * as CANNON from 'cannon-es';
import { debris } from './entities';
import { smoke, sparks } from './particles';
import { physMat, world } from './physics';
import { scene, zeroM } from './scene';
import { ROAD_W, S } from './state';
import { rnd } from './util';

export let cars = null, headL = null, tailL = null; export const carList = []; export const CAR_N = 160;
export const headMat = new THREE.MeshBasicMaterial({color:new THREE.Color(3.5,3.2,2.6), fog:false}); export const tailMat = new THREE.MeshBasicMaterial({color:new THREE.Color(3,0.25,0.15), fog:false});
export const carGeo = new THREE.BoxGeometry(4.4, 1.5, 1.9); carGeo.translate(0, 0.9, 0);
export const carMat = new THREE.MeshStandardMaterial({roughness:.4, metalness:.5, envMapIntensity:1});
export const CAR_COLORS = ['#d9d4c7','#2a2a2e','#8a8f96','#b3b8bf','#5a1e1e','#1e2e4a','#e8e2d0','#3a3a3a'];
export function buildTraffic(data){
  if (cars){ scene.remove(cars); cars.dispose(); cars = null; } carList.length = 0;
  for (const m of [headL, tailL]) if (m){ scene.remove(m); m.dispose(); } headL = tailL = null;
  const roads = data.roads.filter(r => (ROAD_W[r.type]||6) >= 7 && r.pts.length >= 2);
  if (!roads.length) return;
  cars = new THREE.InstancedMesh(carGeo, carMat, CAR_N); cars.castShadow = true;
  for (let i=0;i<CAR_N;i++){
    const r = roads[(Math.random()*roads.length)|0];
    carList.push({r, seg:(Math.random()*(r.pts.length-1))|0, t:Math.random(), dir:Math.random()<.5?1:-1, v:rnd(9,16), alive:true, side:(ROAD_W[r.type]||6)*0.22});
    cars.setColorAt(i, new THREE.Color(CAR_COLORS[(Math.random()*CAR_COLORS.length)|0]));
  }
  cars.instanceColor.needsUpdate = true; scene.add(cars);
  for (const m of [headL, tailL]) if (m){ scene.remove(m); m.dispose(); }
  headL = new THREE.InstancedMesh(new THREE.BoxGeometry(0.3, 0.3, 1.5), headMat, CAR_N); tailL = new THREE.InstancedMesh(new THREE.BoxGeometry(0.25, 0.25, 1.5), tailMat, CAR_N); scene.add(headL); scene.add(tailL);
}
export const _cm = new THREE.Matrix4(), _cq = new THREE.Quaternion(), _cp = new THREE.Vector3(), _cs = new THREE.Vector3(1,1,1), _ce = new THREE.Euler();
let sampleIdx = 0;
export function updateTraffic(dt){
  if (!cars) return; const photo = S.world==='photo';
  if (photo) for (let k=0;k<6;k++){ const c = carList[sampleIdx++ % carList.length]; if (c && c.alive && c.px !== undefined) c.gy = groundAt(c.px, c.pz, c.gy || 0); }
  for (let i=0;i<carList.length;i++){
    const c = carList[i]; if (!c.alive){ continue; }
    const pts = c.r.pts; const a = pts[c.seg], b = pts[c.seg+1]; const L = Math.hypot(b[0]-a[0], b[1]-a[1]) || 1;
    c.t += c.dir * c.v * dt / L;
    if (c.t > 1){ c.seg++; c.t = 0; if (c.seg >= pts.length-1){ c.seg = pts.length-2; c.dir = -1; c.t = 1; } }
    else if (c.t < 0){ c.seg--; c.t = 1; if (c.seg < 0){ c.seg = 0; c.dir = 1; c.t = 0; } }
    const A = pts[c.seg], B = pts[c.seg+1]; const dx = B[0]-A[0], dz = B[1]-A[1]; const l = Math.hypot(dx,dz)||1;
    const nx = -dz/l*c.side*c.dir, nz = dx/l*c.side*c.dir;
    _cp.set(A[0]+dx*c.t+nx, photo ? (c.gy || 0) + 0.9 : 0.3, A[1]+dz*c.t+nz); c.px = _cp.x; c.pz = _cp.z;
    _ce.set(0, Math.atan2(-dx*c.dir, -dz*c.dir) + Math.PI/2, 0); _cq.setFromEuler(_ce);
    _cm.compose(_cp, _cq, _cs); cars.setMatrixAt(i, _cm);
    if (headL){ const fx = Math.sin(_ce.y), fz = Math.cos(_ce.y); _cp.y = 0.9; _cp.x += fx*2.2; _cp.z += fz*2.2; _cm.compose(_cp, _cq, _cs); headL.setMatrixAt(i, _cm); _cp.x -= fx*4.4; _cp.z -= fz*4.4; _cm.compose(_cp, _cq, _cs); tailL.setMatrixAt(i, _cm); }
  }
  cars.instanceMatrix.needsUpdate = true; if (headL){ headL.instanceMatrix.needsUpdate = true; tailL.instanceMatrix.needsUpdate = true; }
}
export function killCarsNear(x, z, r, kick){
  if (!cars) return;
  for (let i=0;i<carList.length;i++){ const c = carList[i]; if (!c.alive) continue;
    cars.getMatrixAt(i, _cm); _cp.setFromMatrixPosition(_cm);
    if (Math.hypot(_cp.x-x, _cp.z-z) < r){ c.alive = false; cars.setMatrixAt(i, zeroM); if (headL){ headL.setMatrixAt(i, zeroM); tailL.setMatrixAt(i, zeroM); headL.instanceMatrix.needsUpdate = tailL.instanceMatrix.needsUpdate = true; } S.carsHit++;
      for (let k=0;k<14;k++) sparks.emit(_cp, new THREE.Vector3(0,12,0), 18, 0.6);
      for (let k=0;k<6;k++) smoke.emit(_cp, new THREE.Vector3(0,6,0), 3, 2.5);
      const body = new CANNON.Body({mass:1.2, material:physMat, shape:new CANNON.Box(new CANNON.Vec3(2.2,0.75,0.95))}); body.position.set(_cp.x, 1.5, _cp.z);
      body.velocity.set((_cp.x-x)/r*kick+rnd(-4,4), 8+Math.random()*10, (_cp.z-z)/r*kick+rnd(-4,4)); body.angularVelocity.set(rnd(-4,4),rnd(-4,4),rnd(-4,4)); world.addBody(body);
      const mesh = new THREE.Mesh(carGeo, new THREE.MeshStandardMaterial({color:'#1a1614', roughness:.9})); mesh.castShadow = true; scene.add(mesh);
      debris.push({mesh, body, born:performance.now()});
    } }
  cars.instanceMatrix.needsUpdate = true;
}

import { groundAt } from '../world/tiles';
